export default __webpack_public_path__ + "static/go-mastercard-843595df11426f11d4ab37512a23761e.webp";